var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
var CollectionEntries = function (_a) {
    var collection = _a.collection, renderEntry = _a.renderEntry, keyPrefix = _a.keyPrefix;
    var _b = __read(useState(null), 2), cachedCollection = _b[0], setCachedCollection = _b[1];
    useEffect(function () {
        if (collection)
            setCachedCollection(collection);
    }, [collection]);
    return (_jsx(_Fragment, { children: cachedCollection === null || cachedCollection === void 0 ? void 0 : cachedCollection.map(function (entry, index) { return (_jsx(React.Fragment, { children: renderEntry && renderEntry(entry) }, (keyPrefix ? keyPrefix : "collection") + "-entry-" + entry.id + "-" + index)); }) }, void 0));
};
export { CollectionEntries };
